import React from "react";
import { Route, Switch } from "react-router-dom";
import { DateTime } from "luxon";

// hooks and utilities
import { useLanguage, useTranslate } from "lang/Translate";

// common components
import LanguageToggle from "components/common/LanguageToggle/LanguageToggle";

//components
import Login from "components/auth/Login";
import Signup from "components/auth/Signup";
import Gallery from "./Gallery/Gallery";

//css
import "./Home.scoped.scss";

//img
import logo from "assets/images/logo.svg";

const descriptionPl = `Airlines Group Manager to gra strategiczna, w której gracz wciela się w rolę prezesa linii lotniczych. Gra zaczęła powstawać w 2021 roku i jest stale rozwijana. Celem gry jest stworzenie lini lotniczej przynoszącej jak największe zyski, przewożącej ogromne ilości pasażerów oraz posiadającej rozległą siatkę połączeń. W grze gracz może wybierać spośród ponad 500 realistycznych samolotów oraz tworzyć siatki połączeń w oparciu o małe i duże lotniska (w grze mamy ponad 3000 lotnisk). Ważnym aspektem tej lotniczej przygody jest podejmowanie  strategicznych decyzji, które będą miały wpływ na rozwój firmy. Należy mieć na uwadze, że gra jest we wczesnym etapie rozwoju i może posiadać błędy. Prosimy o ich zgłaszanie pod adres e-mail podany w regulaminie gry.`;

const descriptionEn =
	"Airlines Group Manager is a strategy game in which the player takes on the role of the airline CEO. The development of the game began in 2021 and is constantly being improved. The aim of the game is to create an airline that brings the high profits, transports huge numbers of passengers and has an extensive route network. In the game, the player can choose from over 500 realistic planes and create routes to and from airports both small and big (the game has over 3000 airports). An important aspect of this aviation adventure is making strategic decisions that will influence the growth of the company. Please note that the game is in its early stages of development and may contain bugs. Please report them to the e-mail address provided in the game regulations.";

const Home = () => {
	const isChristmas = DateTime.utc().month === 12 || DateTime.utc().month === 1;
	const lang = useLanguage();

	return (
		<div className="home">
			<main className={`${isChristmas ? "christmas" : ""}`}>
				<div className="background" />
				<header>
					<img src={logo} alt="LOGO" />
					<h1>Airlines Group Manager</h1>
				</header>
				{isChristmas && (
					<ul className="light_rope">
						{[...Array(60)].map((e, i) => (
							<li key={i} />
						))}
					</ul>
				)}
				<div className="language_container">
					<LanguageToggle />
				</div>
				<div className="form_container">
					<Switch>
						<Route path="/" exact>
							<Login />
						</Route>
						<Route path="/signup">
							<Signup />
						</Route>
					</Switch>
				</div>
			</main>
			<div className="scroll_indicator">
				<a href="#info">
					<i className="fa-solid fa-angle-down" />
				</a>
			</div>
			<section className="page" id="info">
				<h3>{lang === "PL" ? "Ujęcia z gry" : "In-game screenshots"}</h3>
				{<Gallery />}
				<div>
					<h3>{useTranslate({ component: "Home", Tkey: "CHARACTERISTICS" })}</h3>
					<BulletPoints />
				</div>

				<div>
					<h3>{lang === "PL" ? "O projekcie" : "About the project"}</h3>
					<p>{lang === "PL" ? descriptionPl : descriptionEn}</p>
				</div>
			</section>
		</div>
	);
};

const BulletPoints = () => {
	return (
		<div className={`list_container`}>
			<ul>
				<li>{useTranslate({ component: "Home", Tkey: "CHARACTERISTIC_1" })}</li>
				<li>{useTranslate({ component: "Home", Tkey: "CHARACTERISTIC_2" })}</li>
				<li>{useTranslate({ component: "Home", Tkey: "CHARACTERISTIC_3" })}*</li>
				<li>{useTranslate({ component: "Home", Tkey: "CHARACTERISTIC_4" })}</li>
			</ul>
		</div>
	);
};

export default Home;
